// in its own file to break dependency cycle error
export const initialValidationState: { [key: string]: string | undefined } = {
  size: undefined,
  extension: undefined,
  dimension: undefined,
};
